<div class="container">

  <div class="row mb-1">
    <div class="col-md-12 d-flex justify-content-between text-end">

      <h5 class="d-inline-flex align-items-center">

        <span class="fw-bold">PACKAGE ID :</span>

        <span class="text-success fw-bold mr-5">
          {{ tripData?.tripCode | uppercase }}
        </span>

        &nbsp;&nbsp;&nbsp;

        <span class="text-primary" *ngIf="status == 1">
          User Generated Trip
        </span>

        <span class="text-primary" *ngIf="status == 2">
          Driver Accepted Trip
        </span>

        <span class="text-primary" *ngIf="status == 3">
          Driver Started Trip
        </span>

        <span class="text-primary" *ngIf="status == 4">
          Trip Completed
        </span>

        <span class="text-primary" *ngIf="status == 5">
          User Cancelled Trip
        </span>

        <span class="text-primary" *ngIf="status == 6">
          Driver Cancelled Trip
        </span>

      </h5>

      <button
        (click)="back()"
        class="btn-shadow d-inline-flex align-items-center btn btn-success">

        <i class="fa fa-arrow-circle-left mr-2"></i>

        Back

      </button>

    </div>
  </div>

  <div class="row mt-2 mb-2">

    <div class="col-md-12">

      <agm-map
        [latitude]="mapCenter.lat"
        [longitude]="mapCenter.lng"
        [zoom]="15"
        (mapReady)="onMapReady($event)"
        style="height:600px;width:100%;">

        <!-- ============================= -->
        <!-- Driver Marker -->
        <!-- ============================= -->

        <agm-marker
          *ngIf="(status == 2 || status == 3) && driverLocation.lat"
          [latitude]="driverLocation.lat"
          [longitude]="driverLocation.lng"
          [iconUrl]="vehicleIcon">
        </agm-marker>

        <!-- ============================= -->
        <!-- Stop Markers -->
        <!-- ============================= -->

        <agm-marker
          *ngFor="let stop of stopMarkers; let i = index"
          [latitude]="stop.lat"
          [longitude]="stop.lng"
          [iconUrl]="getStopIcon(stop.status, i)"
          [label]="'' + stop.label">
        </agm-marker>

      </agm-map>

    </div>

  </div>

</div>